import { TWorkers } from "@consumption/data-access";

export type TTimeSlot = {
  TimeSlotId: string;
  DayOfWeek: number;
  StartTime: string;
  EndTime: string;
}

export type TAccessTime = {
  AccessTimeId?: string;
  Name?: string;
  EarlyAccessMinutes?: number;
  LateAccessToleranceMinutes?: number;
  PreventEarlyExit?: boolean;
  TimeSlots?: TTimeSlot[];
}

export type TProduct = {
  ProductId: string;
  CategoryType: ECategoryType
  Name: string;
  Icon: string | null;
  Workers: TWorkers[];
}

export type TCondition = {
  ConditionId: string;
  Name: string;
  InstallmentCount: number;
  DurationCount: number;
  DurationType: EPlanConditionDurationType;
}

export enum EPlanConditionDurationType {
  Day = 1,
  Month = 2
}

export enum ECategoryType {
  Default = 0,
  Activity = 1,
  Good = 2,
  Service = 3,
  Module = 4
}

export type TFinancialRule = {
  FinancialRuleId: string;
  FixedAmount: number | null;
  RatePerDay: number | null;
  AmountPerDay: number | null;
  ToleranceDays: number;
  MaxAmount: number | null;
  AppliesOffsetDays: number;
}

export type TAdjustmentRule = {
  FinancialAdjustmentId: string;
  Frequency: EPlanAdjustmentRuleFrequency;
  Amount: number;
  Rate: number;
  FinancialIndexId: string | null;
}

export enum EPlanAdjustmentRuleFrequency {  
  Monthly = 3,
  Yearly = 4,
  Renewal = 5
}

export type TFinancialRuleSet = {
  FinancialRuleSetId: string;
  Name: string;
  DiscountRule: TFinancialRule;
  InterestRule: TFinancialRule;
  PenaltyRule: TFinancialRule;
  AdjustmentRule: TAdjustmentRule;
}

export type TCycleFixedInstallment = {
  PlanFixedInstallmentId: string;
  InstallmentIndex: number;
  Amount: number;
}

export type TPlanCycle = {
  CycleId: string;
  PlanId: string;
  Name: string;
  InstallmentCount: number;
  DurationCount: number;
  DurationType: number | EPlanConditionDurationType;
  FixedInstallmentAmount: number;
  TrialDays: number;
  MaxCountPauses: number;
  MaxCountPausedDays: number;
  FixedInstallments: TCycleFixedInstallment[];
  AllowTrialDays?: boolean; //frontend only
  CommissionRate: number | null;
  CommissionAmount: number | null;
  AllowAccessLimit: boolean; //frontend only
  AccessLimit: number | null;
  ConsolidateAccessPerDay: boolean;
  AllowCommission?: boolean; //frontend only
}

export enum EPlanResourceFrequencyType {
  None = 0,
  Daily = 1,
  Monthly = 2,
  Yearly = 3,
  Renewal = 4,
  Weekly = 5
}

export type TPlanResource = { 
  ResourceId: string;
  ProductId: string;
  Product: TProduct;
  FrequencyType: EPlanResourceFrequencyType;
  Count: number | null;
  AmountUnit: number | null;
  AllowExcess: boolean;
  ExceededAmountUnit: number | null;
  TrialDays: number;
  AllowAccumulate: boolean;
  AccessTimeId: string | null;
  AccessTime: TAccessTime;
  ResourcesRanges?: TResourcesRanges[];
}

export type TPlan = {
  PostPaid: boolean; //front-end only
  PlanId: string;
  Name: string;
  Resources: TPlanResource[];
  Cycles: TPlanCycle[];
  FinancialRuleSetId: string | null;
  FinancialRuleSet?: TFinancialRuleSet;
  PlansAccessesTimes?: TPlanAccessTime[];
}

export type TPartialPlan = {
  PlanId: string;
  Name: string;
}

export type TResourcesRanges = {
  ResourceRangeId?: string;
  Index: number;
  StartRange: number;
  EndRange: number;
  Amount: number;
}

export enum EConsumptionType {
  Unitary,
  Ranges
}

export type TPlanAccessTime = {
  PlanAccessTimeId?: string;
  PlanId?: string;
  AccessTimeId?: string;
  AccessTime?: TAccessTime;
}

export enum ESubscriptionIds {
  PLAN = 'plan',
  PACKS = 'packs',
  FINANCIAL_RULE_SETS = 'financial-rule-sets-section',
  ACCESS_TIME = 'access-time-section',
}

export const subscriptionsPageFragments = [
  {
    title: 'SETTINGS.SUBSCRIPTIONS.SUMMARY.SUBSCRIPTION_CONFIG',
    id: ESubscriptionIds.PLAN,
  },
  {
    title: 'SETTINGS.SUBSCRIPTIONS.SUMMARY.PACKS',
    id: ESubscriptionIds.PACKS
  },
  {
    title: 'SETTINGS.SUBSCRIPTIONS.SUMMARY.FINANCIAL_RULE_SETS',
    id: ESubscriptionIds.FINANCIAL_RULE_SETS
  },
  {
    title: 'SETTINGS.SUBSCRIPTIONS.SUMMARY.ACCESS_TIME',
    id: ESubscriptionIds.ACCESS_TIME
  },
];